export default {
    delHandle: function(list:any,str:any){
        if (typeof str == "string"){
            list.forEach(function(item:HTMLElement){
                item.classList.remove(str);
            })
        }
    }
}